import PrintTaskReport from './PrintTaskReport';

export default PrintTaskReport;
